import { render, staticRenderFns } from "./ProductStatistics.vue?vue&type=template&id=9e4e6fbc&scoped=true&"
import script from "./ProductStatistics.vue?vue&type=script&lang=js&"
export * from "./ProductStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProductStatistics.vue?vue&type=style&index=0&id=9e4e6fbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4e6fbc",
  null
  
)

export default component.exports